document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('customHamburgerBtn');
  const drawer = document.getElementById('customDrawer');
  const overlay = document.getElementById('customDrawerOverlay');
  const closeBtn = document.getElementById('customDrawerClose');

  if (!btn || !drawer || !overlay) return;

  function openDrawer() {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = 'auto';
  }

  btn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
});